'use es6';

import ImmutablePropTypes from 'react-immutable-proptypes';
import { List } from 'immutable';
import PropTypes from 'prop-types';
import { Section } from 'foundations-components/transitional/components/Section';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { H1 } from 'foundations-components/transitional/components/H1';
import { View } from 'foundations-components/components/View';
import PracticalExercise from 'academy-shared-js/records/PracticalExercise';
import Quiz from 'academy-shared-js/records/Quiz';
import ProfessorList from '../LessonPage/ProfessorList';
import UsageTracker from '../../utils/UsageTracker';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { getHumanizedDuration } from '../../utils/utils';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { useTheme } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobilePaddedUISection = props => {
  const {
    isTablet
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(Section, Object.assign({
    paddingInline: isTablet ? '300' : '400'
  }, props));
};
const TrackIntroductionInformation = ({
  track,
  trackVideoDurationInSeconds,
  trackContent,
  trackLessons
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const videoLength = getHumanizedDuration(trackVideoDurationInSeconds);
  const numQuizzes = trackContent.count(content => content instanceof Quiz);
  const numPracticalExercises = trackContent.count(content => content instanceof PracticalExercise);
  const trackProfessors = List.isList(trackLessons) ? trackLessons.flatMap(thisLesson => thisLesson && thisLesson.get('professors')).groupBy(professor => professor.get('id')).map(professor => professor.first()).toList() : List();
  const handleOrganisationUrlClick = (professorId, organisation, organisationUrl) => () => {
    UsageTracker.track('interaction', {
      action: 'professor-organisation-click',
      contentType: 'COURSE',
      appearsIn: 'courses',
      organisation,
      organisationUrl,
      professorId,
      trackId: track.get('id')
    });
  };
  const theme = useTheme();
  return /*#__PURE__*/_jsxs(View, {
    marginBlockStart: "900",
    children: [/*#__PURE__*/_jsx(MobilePaddedUISection, {
      children: /*#__PURE__*/_jsx(H1, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.tracks.aboutThisTrack"
        })
      })
    }), /*#__PURE__*/_jsx(MobilePaddedUISection, {
      children: /*#__PURE__*/_jsxs(TFlex, {
        align: "baseline",
        direction: "row",
        gap: theme.space['400'],
        justify: "start",
        wrap: "wrap",
        children: [/*#__PURE__*/_jsx(View, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            "data-test-id": "track-intro-lesson-count",
            message: "learningCenter.tracks.lessons",
            options: {
              numLessons: track.get('lessonIds').count()
            }
          })
        }), /*#__PURE__*/_jsx(View, {
          borderInlineStartColor: "border-core-default",
          borderInlineStartStyle: "solid",
          borderInlineStartWidth: "100",
          paddingInlineStart: "400",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            "data-test-id": "track-intro-track-duration",
            message: "learningCenter.tracks.totalVideoLengthDuration",
            options: {
              videoLength
            }
          })
        }), !!numQuizzes && /*#__PURE__*/_jsx(View, {
          borderInlineStartColor: "border-core-default",
          borderInlineStartStyle: "solid",
          borderInlineStartWidth: "100",
          paddingInlineStart: "400",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "learningCenter.tracks.quizzes",
            options: {
              numQuizzes
            }
          })
        }), !!numPracticalExercises && /*#__PURE__*/_jsx(View, {
          borderInlineStartColor: "border-core-default",
          borderInlineStartStyle: "solid",
          borderInlineStartWidth: "100",
          paddingInlineStart: "400",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "learningCenter.tracks.practicalExercises",
            options: {
              numPracticalExercises
            }
          })
        })]
      })
    }), /*#__PURE__*/_jsx(MobilePaddedUISection, {
      children: track.get('description')
    }), /*#__PURE__*/_jsx(Section, {
      children: /*#__PURE__*/_jsx(View, {
        paddingInline: isMobile ? '200' : '400',
        children: /*#__PURE__*/_jsx(ProfessorList, {
          handleOrganisationUrlClick: handleOrganisationUrlClick,
          i18nHeading: "learningCenter.tracks.trackProfessors",
          isAccordion: isMobile,
          professors: trackProfessors
        })
      })
    })]
  });
};
TrackIntroductionInformation.propTypes = {
  track: ImmutablePropTypes.map.isRequired,
  trackContent: ImmutablePropTypes.listOf(ImmutablePropTypes.record).isRequired,
  trackLessons: ImmutablePropTypes.listOf(ImmutablePropTypes.map).isRequired,
  trackVideoDurationInSeconds: PropTypes.number.isRequired
};
export default TrackIntroductionInformation;